import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import styles from './SbSharedRelatedItems.scss';
import { createFragmentContainer, graphql } from 'react-relay';
import { SharedItemTile } from '../../shared/SharedItemTile/SharedItemTile';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { QuickViewProvider } from '../../global/QuickViewProvider/QuickViewProvider';

const SbSharedRelatedItemsComponent = ({ itemSearch, user, currency, isClient, viewer }) => {
    const relatedItems = get(itemSearch, 'relatedItems.edges') || [];
    const isVerifiedTrade = get(user, 'isVerifiedTrade');
    const { isSeoQuicklookEnabled } = viewer;
    const title = (
        <FormattedMessage id="sb.SbSharedRelatedItems.title" defaultMessage="Related Items" />
    );

    if (relatedItems.length > 0) {
        return (
            <>
                <BarHeader title={title} />
                <QuickViewProvider>
                    {({ quickView }) => {
                        const quickViewProps = isSeoQuicklookEnabled ? quickView : null;

                        return (
                            <div className={styles.container}>
                                {relatedItems.map(({ node }, index) => (
                                    <SharedItemTile
                                        isClient={isClient}
                                        key={node.serviceId}
                                        index={index}
                                        item={node}
                                        currency={currency}
                                        isVerifiedTrade={isVerifiedTrade}
                                        showSellerName={false}
                                        viewer={viewer}
                                        quickViewProps={quickViewProps}
                                        itemSearch={null}
                                    />
                                ))}
                            </div>
                        );
                    }}
                </QuickViewProvider>
            </>
        );
    }
    return null;
};

SbSharedRelatedItemsComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    user: PropTypes.object,
    viewer: PropTypes.object,
    currency: PropTypes.string.isRequired,
    isClient: PropTypes.bool.isRequired,
};

export const SbSharedRelatedItems = createFragmentContainer(SbSharedRelatedItemsComponent, {
    itemSearch: graphql`
        fragment SbSharedRelatedItems_itemSearch on ItemSearchQueryConnection {
            relatedItems: thinBrowseRelatedItems(first: 12, seller: INCLUDE) {
                edges {
                    node {
                        ...SharedItemTile_item
                        serviceId
                    }
                }
            }
        }
    `,
    user: graphql`
        fragment SbSharedRelatedItems_user on User {
            isVerifiedTrade
        }
    `,
    viewer: graphql`
        fragment SbSharedRelatedItems_viewer on Viewer {
            isSeoQuicklookEnabled: isEnabledByLocale(featureName: "SEO_QUICKLOOK")
            ...SharedItemTile_viewer
        }
    `,
});
